// omnichannel config json headers
export const OMNICHANNEL_HEADER = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};
